<template>
    <div v-bind:class = "(editMode == 'NO') ? 'col-md-6 offset-md-3':'people-management-inner-content'" >
        <div class="form-group">
            <label class="label block-label">Salary to be transferred via <em class="required">*</em> </label>
            <label class="radio-holder ml-0 mb-0">
                Easy Paisa Wallet
                <input v-model="form.accountType" type="radio" @click="form.paymentMethod = 'EASY_PAISA_WALLET'" value="EASY_PAISA_WALLET" id="btn-easy-paisa-wallet" class="payment-transfer" name="paymentTransfer" checked="">
                <span class="checkmark"></span>
            </label>
            <label class="radio-holder ml-0 mb-0">
                Easy Paisa CNIC
                <input v-model="form.accountType" type="radio" @click="form.paymentMethod = 'EASY_PAISA_CNIC'" value="EASY_PAISA_CNIC" id="btn-easy-paisa-cnic" class="payment-transfer" name="paymentTransfer">
                <span class="checkmark"></span>
            </label>
            <label class="radio-holder mb-0">
                IBFT
                <input v-model="form.accountType" type="radio" @click="form.paymentMethod = 'IBFT'" value="IBFT" id="btn-easy-paisa-bank" class="payment-transfer" name="paymentTransfer">
                <span class="checkmark"></span>
            </label>
        </div>
        <div class="payment-via simsim" v-if="form.paymentMethod == 'EASY_PAISA_WALLET'">
            <div class="form-group">
                <label class="label block-label"> Wallet Number  <em class="required">*</em> </label>
                <input v-model="form.accountNumber" placeholder="ex : 923XXXXXXXXX" @keypress="isNumber($event)" @keyup="changeAccountDetail" type="text" maxlength="12" name="accountNumber" class="number-field form-control" :class="{ 'is-invalid': form.errors.has('accountNumber') }" autocomplete="off">
                <has-error :form="form" field="accountNumber"></has-error>
            </div>
            <div class="form-group detail-fetched" v-if="form.account_detail == 'EASY_PAISA_WALLET'">
                <div class="fetched-inner">
                    <div class="fetched-image">
                        <img src="/images/table-dummy-image.jpg" alt="" />
                    </div>
                    <div class="fetched-detail">
                        <h3> {{form.account_information.customer_name}}  </h3>
                        <p> {{form.account_information.account_number}}  </p>
                    </div>
                </div>
                <div class="btn-holder mt-2 mb-2 text-right">
                    <a href="javascript:void(0)" v-if="editMode == 'NO'" class="btn btn-primary" @click="addEmployeePaymentDetail">Save</a>
                </div>
            </div>
            <a href="javascript:void(0)" @click="getEmployeeWalletDetail" class="account fetch-info" title=""> Fetch Info </a>
        </div>
        <div class="payment-via simsim" v-if="form.paymentMethod == 'EASY_PAISA_CNIC'">
            <div class="form-group">
                <label class="label block-label"> Mobile Number  <em class="required">*</em> </label>
                <input v-model="form.mobileNumber" placeholder="ex : 92305xxxxx75" @keypress="isNumber($event)" @keyup="changeAccountDetail" type="text" maxlength="12" name="mobileNumber" class="number-field form-control" :class="{ 'is-invalid': form.errors.has('mobileNumber') }" autocomplete="off">
                <has-error :form="form" field="mobileNumber"></has-error>
            </div>
            <div class="form-group">
                <label class="label block-label"> CNIC Number  <em class="required">*</em> </label>
                <input v-model="form.accountNumber" placeholder="ex : 42401xxxxxxx9" @keypress="isNumber($event)" @keyup="changeAccountDetail" type="text" maxlength="13" name="accountNumber" class="number-field form-control" :class="{ 'is-invalid': form.errors.has('accountNumber') }" autocomplete="off">
                <has-error :form="form" field="accountNumber"></has-error>
            </div>
            <div class="form-group detail-fetched" v-if="form.account_detail == 'EASY_PAISA_CNIC'">
                <div class="fetched-inner">
                    <div class="fetched-image">
                        <img src="/images/table-dummy-image.jpg" alt="" />
                    </div>
                    <div class="fetched-detail">
                        <h3> {{form.account_information.customer_name}} </h3>
                        <p> {{form.account_information.account_number}}  </p>
                    </div>
                </div>
                <div class="btn-holder mt-2 mb-2 text-right">
                    <a href="javascript:void(0)" v-if="editMode == 'NO'" class="btn btn-primary" @click="addEmployeePaymentDetail">Save</a>
                </div>
            </div>
            <a href="javascript:void(0)" @click="getEmployeeWalletDetail" class="account fetch-info" title=""> Fetch Info </a>
        </div>
        <div class="payment-via bank" v-show="form.paymentMethod == 'IBFT'">
            <div class="form-group">
                <label class="label block-label"> Bank Name <em class="required">*</em> </label>
                <select v-model="form.bank" name="bank" class="form-control selectpicker custom-select2" data-live-search="true" :class="{ 'is-invalid': form.errors.has('bank') }" v-if="banks != null">
                    <option value="" selected>Select Bank</option>
                    <option v-for="bank in banks" v-bind:value="{bank_code : bank.bankBin, bank_name : bank.bankName}" v-bind:key="bank.bankBin">
                        {{ bank.bankName }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                <input v-model="form.accountNumber" type="text" name="accountNumber" class="form-control" :class="{ 'is-invalid': form.errors.has('accountNumber') }" autocomplete="off">
                <has-error :form="form" field="accountNumber"></has-error>
            </div>
            <div v-if="form.account_detail == 'IBFT'">
                <h3 class="mb-3"> Fetched Acount Details </h3>
                <div class="fethed-account-detail mb-3">
                    <div class="row">
                        <div class="col-5"> <strong class="title"> Bank Name </strong> </div>
                        <div class="col-7"> {{form.account_information.bank_name}} </div>
                    </div>
                    <div class="row">
                        <div class="col-5"> <strong class="title"> Account Number </strong> </div>
                        <div class="col-7"> {{form.account_information.account_number}} </div>
                    </div>
                    <div class="row">
                        <div class="col-5"> <strong class="title"> Account Title </strong> </div>
                        <div class="col-7"> {{form.account_information.customer_name}} </div>
                    </div>
                </div>
                <div class="btn-holder mt-2 mb-2 text-right">
                    <a href="javascript:void(0)" v-if="editMode == 'NO'" class="btn btn-primary" @click="addEmployeePaymentDetail">Save</a>
                </div>
            </div>
            <a href="javascript:void(0)" @click="getEmployeeWalletDetail" class="account get-info" title=""> Fetch Info </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            "form","banks","getEmployeeWalletDetail","addEmployeePaymentDetail","changeAccountDetail","editMode"
        ],
        data() {
            return {
            };
        },
 
        methods: {
        }
    };
</script>